import usePromoTracking from '~/shared/utils/usePromoTracking';

const useAssetCardTracking = ({ imageFilename, label, options, container }) => {
  const { triggerPromoTracking } = usePromoTracking();

  const imageTrackingData = { imageFilename, label, options, container };

  const trackAssetClick = () => triggerPromoTracking(imageTrackingData);

  return {
    imageTrackingData,
    trackAssetClick,
  };
};

export default useAssetCardTracking;
